import { getExistingSkillLevels, getSkills, getWorkerSkills, changeWorkerSkill, deleteWorkerSkill, addWorkerSkill } from '../api';
import { sortArrayByFieldAsc } from '../helpers/general';
import { GET_ALL_SKILLS_SUCCESS, GET_WORKER_SKILLS_SUCCESS, GET_SKILL_LEVELS_SUCCESS } from './actionTypes';
import { dispatchErrorAction } from './index';

export function getAllSkills () {
  return dispatch => getSkills()
    .then(data => {
      const sortedSkillList = sortArrayByFieldAsc(data.data, 'skill_label');
      dispatch({ type: GET_ALL_SKILLS_SUCCESS, skills: sortedSkillList });
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function getSkillLevels () {
  return dispatch => getExistingSkillLevels()
    .then(data => {
      const sortedSkillLevelsList = sortArrayByFieldAsc(data.data, 'ranking_number');
      dispatch({ type: GET_SKILL_LEVELS_SUCCESS, skills: sortedSkillLevelsList });
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function getWorkerSkillsAction (workerId) {
  return dispatch => getWorkerSkills(workerId)
    .then(data => {
      const sortedWorkerSkills = sortArrayByFieldAsc(data.data, 'skill_label');
      dispatch({ type: GET_WORKER_SKILLS_SUCCESS, workerSkills: sortedWorkerSkills });
    })
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function changeWorkerSkillAction (skillData) {
  return dispatch => changeWorkerSkill(skillData)
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function deleteWorkerSkillAction (workerSkillId) {
  return dispatch => deleteWorkerSkill(workerSkillId)
    .catch(error => dispatchErrorAction(error, dispatch));
}

export function addWorkerSkillAction (workerId, skillId, levelId) {
  return dispatch => addWorkerSkill(workerId, skillId, levelId)
    .catch(error => dispatchErrorAction(error, dispatch));
}



// WEBPACK FOOTER //
// ./src/actions/skills.js